import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setYaprakSekli, setYaprakTipi, setMainType, setAgacCali } from '../../../../../store/actions/resultInfo'
import { getCall, baseUrl } from '../../../../../helpers/api'
import queryString from 'query-string'
import Card from '../cards/card'
import CardContainer from '../card-container/cardContainer'
import CardHolder from '../../card-holder/cardHolder'
import CardTitle from '../../card-title/card-title'


class ResultCardsExample extends Component {

    constructor(props) {
        super(props)
        this.state = {
            results: []
        }
    }

    async componentDidMount() {
        const values = queryString.parse(this.props.location.search)
        setMainType(values.t)
        setAgacCali(values.ac)
        setYaprakSekli(values.ys)
        setYaprakTipi(values.yt)
        const results = await getCall("/resultTree/getWithParams", { values })
        await this.setState({ results: results.data })

    }

    render() {
        return (
            <CardContainer>
                <CardTitle title="Bunlardan Hangisi" />

                <CardHolder>
                    {this.state.results.map((r, index) => (
                        <Card key={index} history={this.props.history} id={r._id} image={baseUrl + r.image} name={r.name} />
                    ))}
                
                </CardHolder>
            </CardContainer>
        )
    }
}

export default connect((store) => ({ resultInfo: store.resultInfo }), {})(ResultCardsExample)
